{
  "noAssignedModeling": "Kein Projekt ausgewählt",
  "modelings": "Projekte",
  "pleaseSignIn": "Bitte anmelden",
  "email": "Email",
  "enterLogin": "Eingabe Benutzername",
  "signIn": "anmelden",
  "password": "Passwort",
  "enterPassword": "Eingabe Passwort",
  "filterByName": "Filter nach Name",
  "settings": "Einstellungen",
  "logout": "Logout",
  "home": "Übersicht",
  "users": "Nutzer",
  "areas": "Gebiete",
  "modelingName": "Projektname",
  "passwordChange": "Passwort ändern",
  "close": "Schließen",
  "confirm": "Bestätigen",
  "userDelete": "Nutzer löschen",
  "wannaDeleteThisUser": "Wollen Sie den Nutzer löschen?",
  "delete": "Löschen",
  "modelingDelete": "Projekt löschen",
  "wannaDeleteThisModeling": "Wollen Sie das Projekt löschen?",
  "userCreation": "Nutzer anlegen",
  "create": "Anlegen",
  "name": "Name",
  "enterUserName": "Eingabe Benutzername",
  "loginName": "Benutzername",
  "role": "Rolle",
  "chooseRole": "Rolle auswählen",
  "viewer": "Betrachter",
  "admin": "Admin",
  "team": "Team",
  "teamName": "Teambezeichnung",
  "group": "Gruppe",
  "groups": "Gruppen",
  "chooseGroup": "Gruppe auswählen",
  "choose": "Auswählen",
  "groupCreation": "Gruppe anlegen",
  "enterGroupName": "Eingabe Gruppenbezeichnung",
  "groupDetail": "Gruppen Details",
  "save": "Speichern",
  "userDetail": "Nutzer Details",
  "modelingCreation": "Projekt anlegen",
  "modelingDetail": "Projekt Details",
  "datasetList": "Dataset",
  "assetTypeList": "Asset Liste",
  "activityList": "Maßnahmen",
  "lifeCycleList": "Lebenszyklen",
  "description": "Beschreibung",
  "benefitList": "Nutzen",
  "forecastList": "Prognose",
  "budgetList": "Budgets",
  "performanceList": "Performance",
  "activityDelete": "Maßnahme löschen",
  "wannaDeleteThisActivity": "Wollen Sie die Maßnahme löschen?",
  "lifeCycleDelete": "Lebenszyklus löschen",
  "wannaDeleteThisLifeCycle": "Wollen Sie den Lebenszyklus löschen?",
  "benefitDelete": "Nutzen löschen",
  "wannaDeleteThisBenefit": "Wollen Sie den Nutzen löschen?",
  "performanceDelete": "Verhaltensentwicklung löschen",
  "wannaDeleteThisPerformance": "Wollen Sie die Verhaltensentwicklung löschen?",
  "unit": "Einheit",
  "unitCost": "Einheitspreis",
  "rootActivity": "Finale Maßnahme",
  "activityColor": "Maßnahmenfarbe",
  "activityCreate": "Maßnahme anlegen",
  "activityDetail": "Maßnahmen Details",
  "costFactor": "Kostenfaktor",
  "benefitCreate": "Nutzen anlegen",
  "benefitAttributes": "Nutzen Attribute",
  "weight": "Gewicht",
  "biggerMoreBenefit": "größerer Wert, mehr Nutzen",
  "mandatoryActAttr": "Attribut Fixe Maßnahme",
  "mandatoryActYearAttr": "Attribut Jahr Fixe Maßnahme",
  "performance": "Performance",
  "performanceName": "Name",
  "performanceDescription": "Beschreibung", 
  "performanceLifespan": "Nutzungsdauer",
  "performanceRanges": "Zustandsklassen",
  "startTheoreticalAge": "VON Alter theor.",
  "endTheoreticalAge": "BIS Alter theor.",
  "startAssetPerformance": "VON Zustand Asset",
  "endAssetPerformance": "BIS Zustand Asset",
  "startIAPP": "von IAPP",
  "endIAPP": "bis IAPP",
  "color": "Farbe",
  "lifeCycleActivities": "Maßnahmen im Lebenzyklus",
  "activityName": "Maßnahme Bezeichnung",
  "activityUnitCost": "Maßnahme Einheitspreis",
  "activityCostFactor": "Maßnahme Kostenfaktor",
  "minAge": "VON Alter",
  "maxAge": "BIS Alter",
  "noAct": "Jahre keine Maßnahme",
  "significant": "Basisnutzen",
  "effect": "Wirkung",
  "changeToLifeCycleId": "Wechseln zu Lebenszyklus Id",
  "notFirst": "nicht als Erste",
  "root": "final",
  "lifeCycleFilters": "Lebenszyklus Filter",
  "sign": "Bedingung",
  "number": "Wert",
  "lifeCycleCreate": "Lebenszyklus anlegen",
  "lifeCycleDetail": "Lebenszyklen Details",
  "activity": "Maßnahme",
  "datasetDetail": "Dataset Details",
  "addAssetType": "Asset hinzufügen",
  "addPerformance": "Performance hinzufügen",
  "addBenefit": "Nutzen hinzufügen",
  "addLifeCycle": "Lebenszyklus hinzufügen",
  "addDataset": "Dataset hinzufügen",
  "addBudget": "Budget hinzufügen",
  "addForecast": "Prognose hinzufügen",
  "addActivity": "Maßnahme hinzufügen",
  "addCostFactor": "Kostenfaktor hinzufügen",
  "inputModel": "Eingangsdaten",
  "analysis": "Analyse",
  "results": "Ergebnisse",
  "datasetCreate": "Dataset anlegen",
  "assetTypeDetail": "Asset Details",
  "forecastCreate": "Prognose anlegen",
  "assetTypeCreate": "Asset anlegen",
  "budgetCreate": "Budget anlegen",
  "budgetDetail": "Budgets Details",
  "performanceCreate": "Performance anlegen",
  "performanceDetail": "Performance Details",
  "select": "auswählen",
  "signif": "Basisnutzen",
  "changeToLifeCycle": "Wechsel zu Lebenszyklus",
  "benefitDetail": "Nutzen Details",
  "back": "Zurück",
  "assetType": "Asset",
  "incorrectUserOrPassword": "Benutzername oder Passwort falsch",
  "startYear": "Anfangsjahr",
  "endYear": "Endjahr",
  "inflationRate": "Inflationsrate",
  "discountRate": "Diskontrate",
  "forecastAssetTypes": "Assets",
  "assetTypes": "Assets",
  "assetAttr": "Asset Attribut",
  "ageAttr": "Alter Attribut",
  "dataset": "Dataset",
  "lifeCycles": "Lebenszyklen",
  "forecastAssetTypeLifeCycles": "Lebenszyklen",
  "addAssetTypeLifeCycle": "Lebenszyklen hinzufügen",
  "forecastUpdate": "Prognose Details",
  "mandatoryVariants": "Varianten fixe Maßnahmen",
  "forecast": "Prognose",
  "allowBreakLifecycleVariants": "unterbrochener Lebenszyklus erlaubt",
  "unlimitedBudget": "unbegrenztes Budget",
  "frameworkBudget": "Rahmenbudget",
  "packageDescription": "Package Beschreibung",
  "budgetPackages": "Budget Packages",
  "predictiveYear": "Jahr",
  "map": "Karte",
  "data": "Daten",
  "Settle": "Settle",
  "Upload": "hochladen",
  "attribute": "Attribut",
  "value": "Wert",
  "budget": "Budget",
  "budgetYearly": "jährliches Budget",
  "percentage": "Anteil",
  "inputType": "Eingabe Typ",
  "inputValue": "Eingabe Wert",
  "showYearlyBudgetPackages": "Jährliches Budget",
  "budgetDelete": "Budget löschen",
  "wannaDeleteThisBudget": "Wollen Sie dieses Budget löschen?",
  "datasetDelete": "Datenset löschen",
  "wannaDeleteThisDataset": "Wollen Sie dieses Datenset löschen??",
  "budgetAssetTypes": "Budget Asset",
  "lifeCycle": "Lebenszyklus",
  "budgetPackage": "Budget Package",
  "benefitWeight": "Gewicht Nutzen",
  "none": "Leer",
  "leading": "Übernehmen",
  "alias": "Alias",
  "headerName": "Bezeichnung Dataset",
  "infosetAttributes": "Dataset Attribute",
  "assetAttribute": "Asset Attribut",
  "lifeCycleAgeAttribute": "Lebenszyklusalter Attribut",
  "weightAttribute": "Gewicht Attribut",
  "selectionDetail": "Auswahl Details",
  "packages": "Packages",
  "limits": "Limits",
  "filterAttributeName": "Filter Attribute",
  "filterSign": "Bedingung",
  "filterValue": "Wert",
  "limitDetail": "Limits Details",
  "package": "Package",
  "selectionLimitPackages": "Auswahl Packages/Limits",
  "years": "Jahre",
  "limit": "Limit",
  "totalLimitValue": "Gesamtlimit",
  "limitValue": "Limit/Anteil jährl.",
  "selectionInfo": "Auswahl Info",
  "selectionMethod": "Auswahlmethode",
  "detail": "Details",
  "addGroup": "Gruppe hinzufügen",
  "addPackage": "Package hinzufügen",
  "addLimit": "Limit hinzufügen",
  "selectionDelete": "Auswahl löschen",
  "wannaDeleteThisSelection": "Wollen Sie diese Auswahl löschen?",
  "analysisSelection": "Analyse",
  "addSelection": "Auswahl hinzufügen",
  "selectionAreaAssetTypes": "Assets im Gebiet",
  "groupCreate": "Gruppe anlegen",
  "packageLifeCycleViewModel": "Lebenszyklen im Package",
  "inputMethod": "Methode",
  "packageCreate": "Package anlegen",
  "packageDetail": "Packages Details",
  "unlimited": "unbegrenzt",
  "benefit": "Nutzen",
  "custom": "ben.def.",
  "yearly": "jährlich",
  "divided": "anteilig",
  "limitCreate": "Limits anlegen",
  "selectionCreate": "Auswahl anlegen",
  "selectionPackageDelete": "Auswahl Package löschen",
  "wannaDeleteThisSelectionPackage": "Wollen Sie dieses Auswahl Package löschen?",
  "selectionLimitDelete": "Auswahl Limit löschen",
  "wannaDeleteThisSelectionLimit": "Wollen Sie dieses Auswahl Limit löschen?",
  "selectionGroupDelete": "Auswahl Gebiete löschen",
  "wannaDeleteThisSelectionGroup": "Wollen Sie diese Auswahl Gebiete löschen?",
  "performanceRangesChart": "Graphik Bereich Verhaltensentwicklung ",
  "lifeCycleActivitiesChart": "Graphik Lebenzyklus Maßnahmen",
  "forecastName": "Prognose",
  "selectionName": "Auswahl",
  "selectionStartYear": "Jahr Start",
  "selectionEndYear": "Jahr Ende",
  "createdDate": "Erstelldatum",
  "simulation": "Simulation",
  "wannaRunSimulation": "Wollen Sie die Simulation ausführen?",
  "runSimulation": "Simulation ausführen",
  "export": "Export",
  "selectionLimitPackageYears": "jährliche Limits",
  "benefitSpecification": "Kontrollspalte Nutzen",
  "testingSection1": "Testing Section 1",
  "testingSection2": "Testing Section 2",
  "copy": "Kopieren",
  "forecastCopy": "Prognose kopieren",
  "wannaCopyThisForecast": "Wollen Sie die Prognose kopieren?",
  "validation": "Validierung",
  "validate": "Validieren",
  "import": "Import",
  "datasets": "Dataset",
  "upload": "Upload",
  "forecasts": "Prognose",
  "selections": "Auswahl",
  "modelingImport": "Import Projekt",
  "areaCreation": "Gebiet anlegen",
  "areaDetail": "Gebiete Details",
  "addArea": "Gebiet hinzufügen",
  "areaCreate": "Gebiet anlegen",
  "area": "Gebiet",
  "modelingResultDetail": "Projekt Detailergebnisse",
  "limitName": "Bezeichnung",
  "conditions": "Zustand",
  "spending": "Kosten",
  "resultDelete": "Ergebnis löschen",
  "wannaDeleteThisResult": "Wollen Sie dieses Ergebnis löschen?",
  "modelingResult": "Ergebnis",
  "forecastDelete": "Prognose löschen",
  "wannaDeleteThisForecast": "Wollen Sie diese Prognose löschen?",
  "dependencies": "Abhängigkeiten",
  "cannotDeleteActivity": "Löschen nicht möglich, Maßnahme verwendet in Lebenszyklus: ",
  "cannotDeleteBenefit": "Löschen nicht möglich, Nutzen verwendet in Auswahl: ",
  "cannotDeletePerformance": "Löschen nicht möglich, Verhaltensentwicklung verwendet in Lebenszyklus: ",
  "cannotDeleteLifeCycle": "Löschen nicht möglich, Lebenszyklus verwendet in Prognose: ",
  "cannotDeleteDataset": "Löschen nicht möglich, Dataset enthält Asset.",
  "cannotDeleteAssetType": "Löschen nicht möglich, Asset verwendet in Prognose: ",
  "assetTypeDelete": "Asset löschen",
  "wannaDeleteThisAssetType": "Wollen Sie diesen Asset löschen?",
  "allDataWillBeLost": "Alle Daten werden gelöscht.",
  "cannotDeleteSelection": "Löschen nicht möglich, Auswahl verwendet in Projektergebnis: ",
  "loading": "Loading",
  "assetTypeNotEmpty": "Löschen nicht möglich, Asset nicht leer.",
  "selectionNotEmpty": "Löschen nicht möglich, Auswahl nicht leer.",
  "selectionAreaDelete": "Auswahl Gebiet gelöscht",
  "activityUpdated": "Maßnahmen erfolgreich aktualisiert!",
  "datasetUpdateSucessfull": "Dataset erfolgreich aktualisiert!",
  "assetTypeUpdated": "Asset erfolgreich aktualisiert!",
  "assetTypeInfosetUpdated": "Asset Infoset erfolgreich aktualisiert!",
  "emptyName": "Name muss gefüllt sein!",
  "benefitUpdated": "Nutzen erfolgreich aktualisiert!",
  "filesUploaded": "Files erfolgreich hochgeladen.",
  "errorWhileUploadingFiles": "Fehler beim Hochladen der Files",
  "errorWhileUploadingFilesWrongType": "Fehler beim Hochladen der Files. Falscher file Type. (erforderlich: .xlsx, .shp, .dbf, .shx)",
  "forecastCopied": "Prognose erfolgreich kopiert!",
  "errorStartEndYearForecast": "Fehler bei Erstellung Prognose, Start- und Endjahr müssen gefüllt sein!",
  "forecastUpdated": "Prognose erfolgreich aktualisiert",
  "lifeCycleUpdated": "Lebenszyklus erfolgreich aktualisiert",
  "missingPerformanceWarning": "Fehler bei Erstellung Lebenszyklus, keine Verhaltensentwicklung ausgewählt!",
  "filtersWarning": "Lebenszyklus Filter enthält ein Attribut, das leer oder gelöscht ist",
  "activitiesError": "Lebenszyklus Maßnahme enthält leeres Attribut!",
  "modelingUpdated": "Projekt erfolgreich aktualisiert!",
  "importSuccess": "Import erfolgreich!",
  "importError": "Import Projekt nicht möglich, Asset nicht ausgewählt!",
  "lifespanError": "Ende Alter theoretisch ist größer als Nutzungsdauer!",
  "performanceUpdated": "Verhaltensentwicklung erfolgreich aktualisiert!",
  "selectionGroupCreated": "Auswahl erfolgreich erstellt!",
  "selectionGroupError": "Fehler bei Erstellung Auswahl!",
  "selectionGroupUpdated": "Auswahl erfolgreich aktualisiert",
  "selectionGroupErrorUpdate": "Fehler bei Aktualisierung Auswahl",
  "selectionLimitCreated": "Limits erfolgreich erstellt!",
  "selectionLimitError": "Fehler bei Erstellung Limits!",
  "selectionLimitUpdated": "Limits erfolgreich aktualisiert",
  "selectionLimitErrorUpdate": "Fehler bei Aktualisierung Limits",
  "limitPackagesMissingValues": "Packages Werte fehlen!",
  "selectionPackageCreated": "Package erfolgreich erstellt!",
  "selectionPackageError": "Fehler bei Erstellung Package!",
  "selectionPackageUpdated": "Package erfolgreich aktualisiert!",
  "selectionPackageErrorUpdate": "Fehler bei Aktualisierung Package!",
  "selectionCreated": "Erfolgreich erstellt!",
  "selectionError": "Fehler bei Erstellung",
  "selectionUpdated": "Erfolgreich aktualisiert!",
  "selectionErrorUpdate": "Fehler bei Aktualisierung",
  "groupUpdated": "Gruppe erfolgreich aktualisiert!",
  "userUpdated": "Nutzer erfolgreich aktualisiert!",
  "warningAttributeRemoved": "Gelöschtes Attribut enthalten, bitte anpassen!",
  "success": "Erfolgreich durchgeführt!",
  "error": "Fehler!",
  "warning": "Warnung!",
  "coreBenefitMethod": "Core Benefit Method",
  "fromStatusAsset": "From Status Asset",
  "toStatusAsset": "To Status Asset",
  "classificationOfAssetAttribute": "Classification of Asset Attribute",
  "mandatoryActCostAttr": "Mandatory Act Cost Attribute",
  "parameters": "Parameters",
  "addParameter": "Add parameter",
  "addCurve": "Add curve",
  "parameterCreate": "Parameter create",
  "parameterDetail": "Parameter detail",
  "parameterAttributeYear": "Parameter Attribute Year",
  "parameterAttribute": "Parameter Attribute",
  "toTheResults": "To the results",
  "startClassification": "Start Classification",
  "endClassification": "End Classification",
  "parameterUpdated": "Parameter updated",
  "downloadZip": "ZIP herunterladen",
  "allGroups": "Alle gruppen",
  "totalPackageCost": "Gesamtkosten des Pakets",
  "summarizedCostCharts": "Zusammengefasste Kosten Diagramme",
  "allAreas": "Alle gebiete",
  "parameterandkpi": "Parameter und KPI",
  "visualizationValue": "Visualisierungswert",
  "coefficientAttribute": "Koeffizientenattribut",
  "coefficientForecastOnly": "Nur Koeffizientenprognose",
  "curveRangeChart": "Kurvenbereichsdiagramm",
  "evaluationDelete": "Bewertung löschen",
  "wannaDeleteThisEvaluation": "Möchten Sie diese Bewertung wirklich löschen?",
  "legend": "Legende",
  "cannotDeleteKeyPerformanceIndicator": "Kann nicht gelöscht werden, da es von folgenden Bewertungen verwendet wird: ",
  "kpiDelete": "KPI löschen",
  "wannaDeleteThisKeyPerformanceIndicator": "Möchten Sie diesen KPI wirklich löschen?",
  "allPackages": "Alle Pakete",
  "analysisStarted": "Die Analyse wurde erfolgreich gestartet!",
  "modelingResultDeleted": "Modellierungsergebnis erfolgreich gelöscht!",
  "wannaDeleteThisModelingResult": "Möchten Sie dieses Modellierungsergebnis wirklich löschen?",
  "parameterContainsCurves": "Dieser Parameter enthält Kurven und kann nicht gelöscht werden.",
  "parameterContainsEvaluation": "Dieser Parameter enthält Bewertungen und kann nicht gelöscht werden."
}
